export default "__VITE_ASSET__DhSm4ZEw__"